import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 pb-0" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_5 = { class: "card bg-primary bg-opacity-10 border-0 rounded-3 mb-4 file-for-dark" }
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_9 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_10 = { class: "card bg-danger bg-opacity-10 border-0 rounded-3 mb-4 file-for-dark" }
const _hoisted_11 = { class: "card-body p-4" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_14 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_15 = { class: "card bg-success bg-opacity-10 border-0 rounded-3 mb-4 file-for-dark" }
const _hoisted_16 = { class: "card-body p-4" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_19 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_20 = { class: "card bg-primary-div bg-opacity-10 border-0 rounded-3 mb-4 file-for-dark" }
const _hoisted_21 = { class: "card-body p-4" }
const _hoisted_22 = { class: "d-flex justify-content-between" }
const _hoisted_23 = { class: "dropdown action-opt ms-2 position-relative top-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-4" }, "My Drive", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input p-0",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault1"
                  })
                ], -1)),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                  _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'More_Option',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex align-items-center py-4 my-3\"><i class=\"material-symbols-outlined fs-45 text-primary\"> folder_open </i><span class=\"fs-15 fw-bold text-secondary ms-2 position-relative top-2\"> Assets </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">387 Files</span><span class=\"fs-13 text-secondary\">4.5 GB</span></div>", 2))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input p-0",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault2"
                  })
                ], -1)),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[3] || (_cache[3] = [
                  _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'More_Option',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex align-items-center py-4 my-3\"><i class=\"material-symbols-outlined fs-45 text-danger\">news</i><span class=\"fs-15 fw-bold text-secondary ms-2 position-relative top-2\"> Projects </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">123 Files</span><span class=\"fs-13 text-secondary\">1.4 GB</span></div>", 2))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input p-0",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault3"
                  })
                ], -1)),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[6] || (_cache[6] = [
                  _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'More_Option',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"d-flex align-items-center py-4 my-3\"><i class=\"material-symbols-outlined fs-45 text-success\">folder</i><span class=\"fs-15 fw-bold text-secondary ms-2 position-relative top-2\">Personal</span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">435 Files</span><span class=\"fs-13 text-secondary\">5.2 GB</span></div>", 2))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "form-check" }, [
                  _createElementVNode("input", {
                    class: "form-check-input p-0",
                    type: "checkbox",
                    value: "",
                    id: "flexCheckDefault4"
                  })
                ], -1)),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[9] || (_cache[9] = [
                  _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-24 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
                ]))])), [
                  [
                    _directive_b_tooltip,
                    'More_Option',
                    void 0,
                    {
                      hover: true,
                      top: true
                    }
                  ]
                ])
              ]),
              _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex align-items-center py-4 my-3\"><i class=\"material-symbols-outlined fs-45 text-primary-div\">folder_open</i><span class=\"fs-15 fw-bold text-secondary ms-2 position-relative top-2\"> Templates </span></div><div class=\"d-flex justify-content-between\"><span class=\"fs-13 text-secondary\">431 Files</span><span class=\"fs-13 text-secondary\">1.3 GB</span></div>", 2))
            ])
          ])
        ])
      ])
    ])
  ]))
}